/* src/app/views/area-publica/header-area-publica/header-area-publica.component.scss */
.height {
  height: 60px;
}
.background {
  background-color: #007AC2;
  padding-top: 15px;
  padding-bottom: 15px;
}
.margin {
  margin: 0 5%;
}
.content {
  padding-top: 5px;
  font-size: 14px;
  color: #ffffff;
}
.content .options {
  font-weight: 700;
}
.content .options a {
  margin-bottom: 11px;
  color: #ffffff;
  text-decoration: none;
}
.content .user {
  font-weight: 500;
}
.content a:link,
.content a:visited,
.content a:active {
  text-decoration: none;
  color: rgb(255, 255, 255);
}
#containerHeaderPublic {
  width: 100% !important;
  justify-content: space-between !important;
  place-content: flex-end flex-start;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
}
/*# sourceMappingURL=header-area-publica.component.css.map */
